module.exports = __webpack_public_path__ + "static/media/background.f2e49501.gif";